'use client';

/**
 * Drop-target mirror for cross-screen window moves (window-management
 * v2, Part IV). While the user drags a window, the canvas publishes
 * which BLANK SCREEN would receive it (geometric containment of the
 * dragged window's center), and the blank screen's sheet subscribes to
 * draw the receiving glow without the canvas re-rendering every node
 * per drag frame. Same module-store pattern as `panel-events` /
 * `presence-bridge`. (The Part III taskbar-drop channel retired with
 * the board taskbar pucks.)
 */

import { useSyncExternalStore } from 'react';

let regionBoardId: string | null = null;
const subs = new Set<() => void>();

function emit(next: string | null) {
  if (next === regionBoardId) return;
  regionBoardId = next;
  subs.forEach((fn) => fn());
}

export function publishRegionDropTarget(boardId: string | null): void {
  emit(boardId);
}

export function clearDropTargets(): void {
  emit(null);
}

function subscribe(cb: () => void): () => void {
  subs.add(cb);
  return () => subs.delete(cb);
}

/** The blank screen whose sheet would receive the dragged window. */
export function useRegionDropTarget(): string | null {
  return useSyncExternalStore(
    subscribe,
    () => regionBoardId,
    () => regionBoardId,
  );
}
